import styled from "styled-components";

export const UserInfoFormContainer = styled.div`
  > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`;
